import { createContext, useContext, useState, type ReactNode } from "react";

interface DetailPageSidebarContextValue {
  showSidebar: boolean;
  setShowSidebar: (show: boolean) => void;
  onSidebarToggleClick?: () => void;
  setOnSidebarToggleClick?: (handler: (() => void) | undefined) => void;
}

const DetailPageSidebarContext = createContext<DetailPageSidebarContextValue | undefined>(undefined);

export function DetailPageSidebarProvider({ children }: { children: ReactNode }) {
  const [showSidebar, setShowSidebar] = useState(true);
  const [onSidebarToggleClick, setOnSidebarToggleClick] = useState<(() => void) | undefined>(undefined);

  return (
    <DetailPageSidebarContext.Provider
      value={{
        showSidebar,
        setShowSidebar,
        onSidebarToggleClick,
        setOnSidebarToggleClick,
      }}
    >
      {children}
    </DetailPageSidebarContext.Provider>
  );
}

export function useDetailPageSidebar() {
  const context = useContext(DetailPageSidebarContext);
  if (!context) {
    return {
      showSidebar: true,
      setShowSidebar: () => {},
      onSidebarToggleClick: undefined,
      setOnSidebarToggleClick: () => {},
    };
  }
  return context;
}

